import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Popover from 'components/common/Popover'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'
import { GrayCheckbox } from '../../../Common.styles'
import { Wrapper as Banner } from 'components/common/Banner/Banner'
import { PopoverWrapper } from '../Kit/Kit'

const FreeAlignmentCheckBlock = ({
  freeAligmentTooltip: {
    tpmsToolTipMessage
  } = {},
  checked,
  isLoading,
  handleToggleCheck
}) =>
  <AlignmentCheckBlock>
    <UpdatingBlock condition={ isLoading }>
      <Title>
        <StyledCheckbox id="free-alignment-checkbox" value={ checked } onChange={ handleToggleCheck }>
          <Bolder>Free</Bolder> Alignment Check
        </StyledCheckbox>
        <DiamondIcon alt="" asset="diamond-green" />
        {
          tpmsToolTipMessage &&
          <PopoverWrapper><Popover small info={ tpmsToolTipMessage } /></PopoverWrapper>
        }
      </Title>
      <Content>
        We want you to get the most out of your tires.
        That’s why we check your suspension and alignment at no extra cost.
      </Content>
    </UpdatingBlock>
  </AlignmentCheckBlock>

FreeAlignmentCheckBlock.propTypes = {
  checked: PropTypes.bool,
  freeAligmentTooltip: PropTypes.shape({
    tpmsToolTipMessage: PropTypes.string
  }),
  handleToggleCheck: PropTypes.func,
  isLoading: PropTypes.bool
}

export default FreeAlignmentCheckBlock

const AlignmentCheckBlock = styled(Banner)`
  line-height: 0;
  margin: 5px 0 30px;
  border-width: 2px;
  border-style: solid;
  border-color: ${Theme.colors.green};
  background: ${Theme.colors.off_white};
  ${Mixin.responsive('padding', '10px 15px 5px', '5px 15px')}
`

const Title = styled.div`
  margin-bottom: 5px;
`

const StyledCheckbox = styled(GrayCheckbox)`
  font-size: 14px;
  text-transform: uppercase;
  display: inline;
`

const Content = styled.p`
  margin: 5px 5px 5px 25px;
  line-height: 16px;
  font-size: 13px;
  min-width: 0;
`

const DiamondIcon = styled(Icon)`
  margin-left: 5px;
  margin-top: -3px;
  width: 15px;
  height: 17px;
`

const Bolder = styled.span`
  font-weight: 700;
  font-style: italic;
`
